import Image from 'next/image';
import cn from 'classnames';
import Link from 'next/link';

const StatsGrid = ({ color, stats = [], marginBottom = false }) => (
  <div
    className={cn(
      'flex flex-col space-y-8 sm:space-y-0 sm:grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-4 xl:gap-8',
      marginBottom && 'mb-14'
    )}
  >
    {stats.map((stat, index) => (
      <div
        className={cn(
          stat.doubleSpan && 'col-span-2',
          'lg:hover:border-neutral-600 lg:hover:bg-neutral-950 group transition-colors rounded-lg border border-tundora bg-neutral-900 px-4 py-6 md:px-6 space-y-6 sm:space-y-4 lg:space-y-6 xl:space-y-7 flex flex-col justify-between'
        )}
        key={index}
      >
        <div className="flex justify-between items-center">
          <p className="font-aeonik text-2xl lg:text-xl xl:text-2xl leading-10">{stat.title}</p>
          <Image
            src={stat.icon.src}
            width={stat.icon.width}
            height={stat.icon.height}
            alt={stat.icon.alt}
          />
        </div>
        <p
          style={{ color: stat.featured ? color : '#FFFFFF' }}
          className={cn(
            stat.featured
              ? 'text-5xl lg:text-3xl xl:text-5xl'
              : 'text-2xl leading-snug lg:text-xl xl:text-3.5xl',
            'sm:text-xl font-medium leading-none'
          )}
        >
          {stat.value}
        </p>
      </div>
    ))}
  </div>
);

export default StatsGrid;
